const PROMOTION_SCHEDULE_ERROR_CODE = {
  PROMOTION_SCHEDULE_001: 'PROMOTIONSCHEDULE001',
  PROMOTION_SCHEDULE_002: 'PROMOTIONSCHEDULE002',
  PROMOTION_SCHEDULE_003: 'PROMOTIONSCHEDULE003',
  PROMOTION_SCHEDULE_004: 'PROMOTIONSCHEDULE004',
  PROMOTION_SCHEDULE_005: 'PROMOTIONSCHEDULE005',
  PROMOTION_SCHEDULE_006: 'PROMOTIONSCHEDULE006',
  PROMOTION_SCHEDULE_007: 'PROMOTIONSCHEDULE007',
  PROMOTION_SCHEDULE_008: 'PROMOTIONSCHEDULE008',
  PROMOTION_SCHEDULE_009: 'PROMOTIONSCHEDULE009',
  PROMOTION_SCHEDULE_010: 'PROMOTIONSCHEDULE010',
  PROMOTION_SCHEDULE_011: 'PROMOTIONSCHEDULE011',
  PROMOTION_SCHEDULE_012: 'PROMOTIONSCHEDULE012',
  PROMOTION_SCHEDULE_013: 'PROMOTIONSCHEDULE013',
  PROMOTION_SCHEDULE_014: 'PROMOTIONSCHEDULE014',
  PROMOTION_SCHEDULE_015: 'PROMOTIONSCHEDULE015',
  PROMOTION_SCHEDULE_016: 'PROMOTIONSCHEDULE016',
  PROMOTION_SCHEDULE_017: 'PROMOTIONSCHEDULE017',
  PROMOTION_SCHEDULE_018: 'PROMOTIONSCHEDULE018',
  PROMOTION_SCHEDULE_019: 'PROMOTIONSCHEDULE019',
  PROMOTION_SCHEDULE_020: 'PROMOTIONSCHEDULE020',
  PROMOTION_SCHEDULE_021: 'PROMOTIONSCHEDULE021',
};

const PROMOTION_SCHEDULE_ERROR_MESSAGE = {
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_001]: '트랙은 필수값이며 유효한 트랙이어야 합니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_002]: '항목명은 필수값인 문자열입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_003]:
    '시작일시는 YYYY-MM-DD 또는 ISO 8601 일시 형식입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_004]:
    '종료일시는 YYYY-MM-DD 또는 ISO 8601 일시 형식입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_005]: '종료일시는 시작일시보다 빠를 수 없습니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_006]: '유효하지 않은 상태입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_007]: '유효하지 않은 기획전 유형입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_008]: '담당자 식별 id는 1 이상의 정수형만 가능합니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_009]: '기획전 식별 id는 1 이상의 정수형만 가능합니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_010]: '메모는 문자열 형식입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_011]:
    '프로모션 스케줄 식별 id는 1 이상의 정수형만 가능합니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_012]: '존재하지 않는 프로모션 스케줄입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_013]: '조회 시작일은 필수값이며 YYYY-MM-DD 형식입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_014]: '조회 종료일은 필수값이며 YYYY-MM-DD 형식입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_015]: '유효하지 않은 트랙이 포함되어 있습니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_016]: '존재하지 않는 담당자입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_017]: '존재하지 않는 기획전입니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_018]: '담당자 필터 값이 올바르지 않습니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_019]: '쿠폰 식별 id는 1 이상의 정수형만 가능합니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_020]: '연결할 쿠폰 목록이 올바르지 않습니다.',
  [PROMOTION_SCHEDULE_ERROR_CODE.PROMOTION_SCHEDULE_021]: '존재하지 않는 쿠폰이 포함되어 있습니다.',
};

export default PROMOTION_SCHEDULE_ERROR_MESSAGE;
